module.exports = __webpack_public_path__ + "static/media/transactions.268ac49c.webp";